import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'pt-covid-result',
  template: `
    <!--  QUI ANDRANNO EVENTUALI RESULT-->
  `
})
export class CovidResultComponent implements OnChanges {
  @Input() docId: number;
  @Input() requireReload: boolean;
  @Input() autoReload = false;

  // constructor(private service: CovidAssessmentsService, private store: Store) {
  // }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes.docId) {
    //   this.reloadResult();
    // }
    //
    // if (changes.requireReload) {
    //   if (this.requireReload && this.autoReload) {
    //     this.reloadResult();
    //   }
    // }
  }

  // private alignWidget(evaluation: CovidAssessmentEvaluation) {
  //
  // }
  //
  // public reloadResult() {
  //   this.service?.getDetails(this.docId).subscribe((result: CovidAssessmentDetails) => {
  //     this.result = result.evaluation;
  //     this.alignWidget(this.result);
  //     this.store.dispatch(NgrxWidgetActions.reloadedResult());
  //   }, () => {
  //     this.result = undefined;
  //     this.store.dispatch(NgrxWidgetActions.reloadedResult());
  //   });
  // }
}
